import { render, staticRenderFns } from "./RequestOrder.vue?vue&type=template&id=08a7d7a6&scoped=true&"
import script from "./RequestOrder.vue?vue&type=script&lang=js&"
export * from "./RequestOrder.vue?vue&type=script&lang=js&"
import style0 from "./RequestOrder.vue?vue&type=style&index=0&id=08a7d7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7d7a6",
  null
  
)

export default component.exports